import { render, staticRenderFns } from "./stopTask.vue?vue&type=template&id=680a967c&"
import script from "./stopTask.vue?vue&type=script&lang=js&"
export * from "./stopTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports